import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import uploadPhoto from "../../Image/upload 1.png";
import "./Registration.css";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  TextField,
  Typography,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: "20px",
  },
  input: {
    display: "none",
  },
}));

const Registration = ({
  modelOpen,
  setModelOpen,
  handleModelOpen,
  handleModelClose,
}) => {
  const classes = useStyles();
  const [name, setName] = React.useState("");
  const handleChange = (event) => {
    setName(event.target.value);
  };
  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={modelOpen}
        onClose={handleModelClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modelOpen}>
          <div className={classes.paper}>
            <div className="RegistrationHeading">
              <Typography variant="h2" className="buttonBodySub">
                Registration Form
              </Typography>
              <Typography variant="h5">
                Fill out this quick form and get started with your Tristar
                Logistics Marketplace ( All fields are mandatory)
              </Typography>
            </div>
            <div className="RegistrationContent">
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Company Trade License Number
                  </InputLabel>

                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Company Name *
                  </InputLabel>
                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
            </div>
            <div className="RegistrationContent">
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Authorized Mobile Number
                  </InputLabel>

                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    {" "}
                    Authorized Email ID*
                  </InputLabel>

                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
            </div>
            <div className="RegistrationContent">
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    Country
                  </InputLabel>

                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
              <Box>
                <FormControl>
                  <InputLabel htmlFor="input-with-icon-adornment">
                    {" "}
                    Enter Rematks (if any)
                  </InputLabel>

                  <br />
                  <br />
                  <br />

                  <TextField id="outlined-helperText" variant="outlined" />
                </FormControl>
              </Box>
            </div>
            <div className="upload_document_main">
              <label>KYC(Upload Documents)</label>
              <div className="RegistrationContent">
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">Trade License</Typography>
                  </div>
                </Box>
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">VAT Certificate</Typography>
                  </div>
                </Box>
                <Box className="upload_document">
                  <div className="">
                    <input
                      accept="image/*"
                      className={classes.input}
                      id="icon-button-photo"
                      type="file"
                    />
                    <label htmlFor="icon-button-photo">
                      <img src={uploadPhoto} alt="uploadPhoto" />
                    </label>
                    <Typography variant="h5">Passport Copy</Typography>
                  </div>
                </Box>
              </div>
            </div>

            <div className="buttonBody">
              <Typography variant="h5" className="buttonBodySub">
                I agree to the following:
              </Typography>
              <Typography variant="h5">
                Agree to the Tristar Business User Terms and Conditions.
              </Typography>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="I agree to all the above"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={handleChange}
                    name="checkedB"
                    color="primary"
                  />
                }
                label="By submission of this form, I hereby confirm that  I am authorized to sign this application form on behalf of the named company above."
              />
            </div>
            <div className="submit-btn">
              <Button>Submit</Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};
export default Registration;
